import React, { Component } from "react";
import CheckDefecto from "../../../../Common/Components/CheckDefecto";
import ExpHelper from '../../../../Common/Helpers/ExpHelper';

export default class DenominacionCuartaLinea extends Component {
    constructor(props) {
        super(props);

        this.state = {
            TextoCuartaLinea: ""
        };
    }

    onCuartaLineaInputChange(event) {
        const { value } = event.target;

        if (/^[a-z\u00E1\u00C1\u00C9\u00E9\u00CD\u00ED\u00D3\u00F3\u00DA\u00FA\u00DC\u00FC\u00D1\u00F1A-Z0-9\s]{0,19}$/g.test(value)) {
            this.setState({
                TextoCuartaLinea: value
            });
        }
    }

    onCuartaLineaInputOnBlur(event) {
        this.props.changeInput("TextoCuartaLinea", event.target.value);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            TextoCuartaLinea: nextProps.data.TextoCuartaLinea
        });
    }

    render() {

        const { state, onCuartaLineaInputChange, onCuartaLineaInputOnBlur } = this;
        const { data, selectCheckBox, selectRadio } = this.props;
        const { GET_DENOMINACION_CUARTA_LINEA, GET_PARAMETRO_GENERAL } = data;
        const acentoLetraIminuscula = ExpHelper.ConvertirCaracter("i");
        const acentoLetraOminuscula = ExpHelper.ConvertirCaracter("o");

        if (GET_PARAMETRO_GENERAL == null || GET_PARAMETRO_GENERAL == undefined) {
            return null;
        }

        if (GET_PARAMETRO_GENERAL.SINODENOMINACIONCUARTALINEA == true) {

            return (
                <div className="row top-separator-xs">
                    <div className="col-xs-12 top-separator-xxs">
                        <label className="label-primary">{"Denominaci" + acentoLetraOminuscula + "n de 4ta. L" + acentoLetraIminuscula + "nea"}</label>
                    </div>
                    <div className="col-xs-12">
                        <CheckDefecto
                            nombre={"Graba 4ta. L" + acentoLetraIminuscula + "nea"}
                            check={data.HabilitaCuartaLinea}
                            referencia={"GRACUALIN"}
                            selectCheckBox={(event) => selectCheckBox("HabilitaCuartaLinea", event.target.checked)}
                        />
                    </div>

                    {data.HabilitaCuartaLinea && <div className="col-xs-12 left-separator-xs top-separator-xxs">
                        {GET_DENOMINACION_CUARTA_LINEA.map((item) => {
                            const id = `GDCL-${item.Id}`;

                            let classRadio = `container-radio${((!data.HabilitaCuartaLinea) ? "-disabled" : "")} radio-margin`;

                            if (data.HabilitaCuartaLinea) {
                                let able = true;
                                switch (item.Descripcion) {
                                    case "Grupo Afinidad":
                                        able = (data.AsociaGrupoAfinidad || (!data.AsociaGrupoAfinidad && item.Descripcion !== "Grupo Afinidad"));
                                        break;
                                    case "Segmento de Cartera":
                                        able = (data.AsociaSegmentoCartera || (!data.AsociaSegmentoCartera && item.Descripcion !== "Segmento de Cartera"));
                                        break;
                                    case "Marca Compartida":
                                        able = (data.AsociaMarcaCompartida || (!data.AsociaMarcaCompartida && item.Descripcion !== "Marca Compartida"));
                                        break;
                                    default:
                                }

                                classRadio = `container-radio${able ? "" : "-disabled"} radio-margin`;

                                if (!able)
                                    item.Checked = false;
                            }

                            return (
                                <div className={classRadio} key={item.Id}>
                                    <div className="row">
                                        <div className="col-xs-4">
                                            <div style={{ clear: "both" }}>
                                                <div style={{ float: "left", marginRight: "15px" }}>
                                                    <input
                                                        id={"deno-" + id}
                                                        type="radio"
                                                        name="TextoCuartaLinea"
                                                        value={item.Id}
                                                        checked={item.Checked}
                                                        data-codigo={item.Codigo}
                                                        onChange={(event) => {
                                                            if (data.HabilitaCuartaLinea) {
                                                                selectRadio("GET_DENOMINACION_CUARTA_LINEA", event.target.value, event.target.dataset.codigo)
                                                            }
                                                        }}
                                                    />
                                                    <label className="lbl-radio label-secondary" htmlFor={"deno-" + id}>{item.Descripcion}</label>
                                                </div>
                                                {item.Id == 5 &&
                                                    <div style={{ width: "200px", float: "left" }}>
                                                        <input
                                                            className="form-control default-input"
                                                            type="text"
                                                            maxLength="19"
                                                            disabled={(!data.HabilitaCuartaLinea || !item.Checked)}
                                                            value={state.TextoCuartaLinea}
                                                            onChange={onCuartaLineaInputChange.bind(this)}
                                                            onBlur={onCuartaLineaInputOnBlur.bind(this)}
                                                        />

                                                    </div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}


                    </div>}
                    <div className="col-xs-12 ">
                        {(data.ERROR_PRODUCT["seleccionoDenominacionCuartaLinea"] == false && data.HabilitaCuartaLinea)
                            && <label className="error">{"Debe seleccionar al menos una denominaci" + acentoLetraOminuscula + "n de 4ta. L" + acentoLetraIminuscula + "nea."}</label>}
                        {(data.TipoGrabadoCuartaLinea == "Texto" && !data.ERROR_PRODUCT.hayTextoCuartaLinea && data.ERROR_PRODUCT["seleccionoDenominacionCuartaLinea"]) && <label className="error">{"Debe completar el cuadro de texto"}</label>}
                    </div>

                </div>
            );
        }
        else {
            return null;
        }
    }
}